import { useEffect } from 'react';

import { getWeddingPreferences as fetchWeddingPreferences } from '~/actions/accountPreferencesActions';
import { useUserContext } from '~/contexts/UserContext';
import { useAppDispatch, useAppSelector } from '~/reducers';
import { WeddingPreferencesState } from '~/reducers/weddingPreferencesReducer';
import { StandardLogFn } from '~/util/logger';

import {
  getWeddingPreferences,
  getHasWeddingPreferences,
  getWeddingPreferencesLoaded,
} from '../selectors/weddingPreferencesSelectors';

let requestedWeddingPreferences = false;

export type UseWeddingPreferencesResult = {
  weddingPreferences: WeddingPreferencesState;
  hasWeddingPreferences: boolean;
  loaded: boolean;
  isGuest: boolean;
  hasMarketplaceAccount: boolean;
};

const useWeddingPreferences = (): UseWeddingPreferencesResult => {
  const userContext = useUserContext();
  const { is_guest: isGuest, has_marketplace_account: hasMarketplaceAccount } = userContext || {};
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!requestedWeddingPreferences && userContext && !isGuest) {
      requestedWeddingPreferences = true;
      dispatch(fetchWeddingPreferences()).catch(StandardLogFn);
    }
  }, [dispatch, isGuest, userContext]);

  return {
    weddingPreferences: useAppSelector(getWeddingPreferences),
    hasWeddingPreferences: useAppSelector(getHasWeddingPreferences),
    loaded: useAppSelector(getWeddingPreferencesLoaded),
    isGuest: Boolean(isGuest),
    hasMarketplaceAccount: Boolean(hasMarketplaceAccount),
  };
};

export default useWeddingPreferences;
